import React, { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { Menu, X } from "lucide-react";

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const links = [
    { to: "/", label: "Home" },
    { to: "/pricing", label: "Pricing" },
    { to: "/contact", label: "Contact Us" },
  ];
  return (
    <header className="sticky top-0 z-40 bg-white/90 backdrop-blur border-b border-[#eef1f6]">
      <div className="max-w-7xl mx-auto px-6 h-[76px] flex items-center justify-between">
        <Link to="/" className="flex items-center">
          <img
            src="/images/somm-logo.png"
            alt="Somm.ai"
            className="h-10 md:h-12 w-auto object-contain"
          />
        </Link>
        <nav className="hidden md:flex items-center gap-10">
          {links.map((l) => (
            <NavLink key={l.to} to={l.to} end className={({ isActive }) => `nav-link ${isActive ? "active" : ""}`}>
              {l.label}
            </NavLink>
          ))}
        </nav>
        <div className="hidden md:flex items-center gap-3">
          <a href="https://app.somm.ai/" target="_blank" rel="noreferrer" className="btn-ghost">Log In</a>
          <a href="https://www.somm.ai/meeting" target="_blank" rel="noreferrer" className="btn-dark">Demo</a>
        </div>
        <button className="md:hidden" onClick={() => setOpen(!open)} aria-label="menu">
          {open ? <X /> : <Menu />}
        </button>
      </div>
      {open && (
        <div className="md:hidden border-t border-[#eef1f6] bg-white">
          <div className="px-6 py-4 flex flex-col gap-3">
            {links.map((l) => (
              <NavLink key={l.to} to={l.to} end onClick={() => setOpen(false)} className="nav-link py-2">{l.label}</NavLink>
            ))}
            <a href="https://app.somm.ai/" target="_blank" rel="noreferrer" onClick={() => setOpen(false)} className="btn-ghost text-left">Log In</a>
            <a href="https://www.somm.ai/meeting" target="_blank" rel="noreferrer" onClick={() => setOpen(false)} className="btn-dark text-center">Demo</a>
          </div>
        </div>
      )}
    </header>
  );
}
